import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchVulnerabilities, fetchScanSummary, triggerScan } from '../../services/api/vulnService';

export const loadVulnerabilities = createAsyncThunk('vulnerabilities/load', async () => {
  // A summary failure must never blank the scanner. Keep the scan list usable.
  const [itemsResult, summaryResult] = await Promise.allSettled([fetchVulnerabilities(), fetchScanSummary()]);
  if (itemsResult.status === 'rejected' && summaryResult.status === 'rejected') throw itemsResult.reason;
  return {
    items: itemsResult.status === 'fulfilled' && Array.isArray(itemsResult.value) ? itemsResult.value : [],
    summary: summaryResult.status === 'fulfilled' ? summaryResult.value : null,
    partialError: itemsResult.status === 'rejected'
      ? (itemsResult.reason?.response?.data?.message || itemsResult.reason?.message)
      : summaryResult.status === 'rejected'
        ? (summaryResult.reason?.response?.data?.message || summaryResult.reason?.message)
        : null,
  };
});

export const runScan = createAsyncThunk('vulnerabilities/runScan', async (target) => triggerScan(target));

const vulnSlice = createSlice({
  name: 'vulnerabilities',
  initialState: { status: 'idle', error: null, items: [], summary: null, lastScanRequest: null, scanStatus: 'idle', scanError: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadVulnerabilities.pending, (state) => { state.status = 'loading'; })
      .addCase(loadVulnerabilities.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.items;
        state.summary = action.payload.summary;
        state.error = action.payload.partialError;
      })
      .addCase(loadVulnerabilities.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(runScan.pending, (state) => { state.scanStatus = 'loading'; state.scanError = null; })
      .addCase(runScan.fulfilled, (state, action) => {
        state.scanStatus = 'succeeded';
        state.lastScanRequest = action.payload;
      })
      .addCase(runScan.rejected, (state, action) => {
        state.scanStatus = 'failed';
        state.scanError = action.error.message || 'Unable to start vulnerability scan.';
      });
  }
});

export default vulnSlice.reducer;
